import React from "react"
import "./style.scss"
import { MainView } from "./view/MainView/main.view.jsx"

export default MainView
